export default __webpack_public_path__ + "static/media/6_adyen.644d69f2.svg";